import { render, staticRenderFns } from "./productSlider.vue?vue&type=template&id=04c0041c&scoped=true"
import script from "./productSlider.vue?vue&type=script&lang=js"
export * from "./productSlider.vue?vue&type=script&lang=js"
import style0 from "./productSlider.vue?vue&type=style&index=0&id=04c0041c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0041c",
  null
  
)

export default component.exports